import { type TranslationKey } from "providers/I18nProvider";
import { TaskPriority, TaskResourceType, TaskStatus } from "types";
import { SortKeyOption, TaskUrgency } from "../types";

export const SORT_OPTIONS: SortKeyOption[] = ["issueDate", "priority"];

export const TASK_TITLE_MAX_LENGTH = 100;
export const TASK_DESCRIPTION_MAX_LENGTH = 500;

export const TASK_TYPE_LABELS: Record<TaskResourceType, TranslationKey> = {
  [TaskResourceType.ContributionPaymentEntity]:
    "apps.admin.pages.tasks.types.PaymentEntity",
  [TaskResourceType.AdjustmentPaymentEntity]:
    "apps.admin.pages.tasks.types.PaymentEntity",
  [TaskResourceType.WithdrawalPaymentEntity]:
    "apps.admin.pages.tasks.types.PaymentEntity",
  [TaskResourceType.FeeDistributionEntity]:
    "apps.admin.pages.tasks.types.PaymentEntity",
  [TaskResourceType.FeePayoutEntity]:
    "apps.admin.pages.tasks.types.PaymentEntity",
  [TaskResourceType.MarketOrderEntity]:
    "apps.admin.pages.tasks.types.MarketOrderEntity",
  [TaskResourceType.CompanyVerificationEntity]:
    "apps.admin.pages.tasks.types.CompanyVerificationEntity",
  [TaskResourceType.KycRequestEntity]:
    "apps.admin.pages.tasks.types.KycRequestEntity",
  [TaskResourceType.ManualTaskEntity]:
    "apps.admin.pages.tasks.types.ManualTaskEntity",
  [TaskResourceType.ProductAssignmentSubscriptionRequestEntity]:
    "apps.admin.pages.tasks.types.ProductAssignmentSubscriptionRequestEntity",
  [TaskResourceType.AttributesCorrectionsRequestEntity]:
    "apps.admin.pages.tasks.types.AttributesCorrectionsRequestEntity",
};

export const PAYMENT_TASK_RESOURCE_TYPES: TaskResourceType[] = [
  TaskResourceType.ContributionPaymentEntity,
  TaskResourceType.AdjustmentPaymentEntity,
  TaskResourceType.WithdrawalPaymentEntity,
  TaskResourceType.FeeDistributionEntity,
  TaskResourceType.FeePayoutEntity,
];

export type TaskTypeFilterOption = {
  id: string;
  labelKey: TranslationKey;
  resourceTypes: TaskResourceType[];
};

export const TASK_TYPE_FILTER_OPTIONS: TaskTypeFilterOption[] = [
  {
    id: "payment",
    labelKey: "apps.admin.pages.tasks.types.PaymentEntity",
    resourceTypes: PAYMENT_TASK_RESOURCE_TYPES,
  },
  ...(Object.keys(TASK_TYPE_LABELS) as TaskResourceType[])
    .filter((type) => !PAYMENT_TASK_RESOURCE_TYPES.includes(type))
    .map((resourceType) => ({
      id: resourceType,
      labelKey: TASK_TYPE_LABELS[resourceType],
      resourceTypes: [resourceType] as TaskResourceType[],
    })),
];

export const TASK_STATUS_TO_BACKEND: Record<TaskStatus, string> = {
  [TaskStatus.Open]: "open",
  [TaskStatus.InReview]: "inReview",
  [TaskStatus.Closed]: "closed",
};

export const TASK_STATUS_LABELS: Record<TaskStatus, TranslationKey> = {
  [TaskStatus.Open]: "apps.admin.pages.tasks.statuses.inProgress",
  [TaskStatus.InReview]: "apps.admin.pages.tasks.statuses.inReview",
  [TaskStatus.Closed]: "apps.admin.pages.tasks.statuses.completed",
};

export const TASK_PRIORITY_TO_BACKEND: Record<TaskPriority, string> = {
  [TaskPriority.Low]: "0",
  [TaskPriority.Medium]: "1",
  [TaskPriority.High]: "2",
};

export const TASK_PRIORITY_LABELS: Record<TaskPriority, TranslationKey> = {
  [TaskPriority.Low]: "apps.admin.pages.tasks.priorities.low",
  [TaskPriority.Medium]: "apps.admin.pages.tasks.priorities.medium",
  [TaskPriority.High]: "apps.admin.pages.tasks.priorities.high",
};

export const TASK_STATUSES = Object.keys(TASK_STATUS_LABELS) as TaskStatus[];

export const TASK_PRIORITIES = Object.keys(
  TASK_PRIORITY_LABELS,
) as TaskPriority[];

export const TASK_STATUS_FILTER_NONE = "none";

export const TASK_PRIORITY_FILTER_NONE = "none";

export const TASK_RESOURCE_TYPES = Object.keys(
  TASK_TYPE_LABELS,
) as TaskResourceType[];

export const DUE_SOON_DAYS = 3;

export const URGENCY_ORDER: Record<TaskUrgency, number> = {
  overdue: 0,
  dueSoon: 1,
  upcoming: 2,
  none: 3,
};
